import { render, staticRenderFns } from "./ProductListLayout.vue?vue&type=template&id=5a8d5928&scoped=true&"
import script from "./ProductListLayout.vue?vue&type=script&lang=ts&"
export * from "./ProductListLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ProductListLayout.vue?vue&type=style&index=0&id=5a8d5928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d5928",
  null
  
)

export default component.exports